import { render, staticRenderFns } from "./AccountRegistrationPopup.vue?vue&type=template&id=00fc7499&"
import script from "./AccountRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./AccountRegistrationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports